/* MetalPlex size picker v1.1 (Oct 20, 2026): guide link on the Size label row, no price on cards, room view inside the size guide. Markup templates and data live in snippets/mp-size-picker.liquid. */
(function () {
  var dataEl = document.getElementById('MpSizeData');
  if (!dataEl) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var meta = dataEl.closest('.product-single__meta') || document;
  var fs = meta.querySelector('.variant-input-wrap[data-index="option' + (D.sizeIndex + 1) + '"]');
  if (!fs) return;
  var wrapper = fs.closest('.variant-wrapper') || fs.parentNode;

  function norm(s) { return String(s).replace(/\s+/g, ' ').trim(); }
  // Size formats in the catalog: 47" x 22" | 36"W x 16.2"H | 20" H x 30" W | W 47" x H 22" | 24" | 30" Height | "Regular (36" W x 18" H)"
  function axisOf(part) {
    var l = part.replace(/[\d."'\s]/g, '').toLowerCase();
    if (/wid/.test(l)) return 'w';
    if (/height|tall/.test(l)) return 'h';
    if (/^h|h$/.test(l)) return 'h';
    if (/^w|w$/.test(l)) return 'w';
    return null;
  }
  function parseSize(raw) {
    var s = norm(raw), inner = s.match(/\(([^)]*\d[^)]*)\)/);
    s = inner ? inner[1] : s.replace(/\([^)]*\)/g, '');
    var parts = s.split(/\s*[x×]\s*/i).filter(function (p) { return /\d/.test(p); });
    var nums = parts.map(function (p) { return parseFloat(p.match(/\d+(?:\.\d+)?/)[0]); });
    if (nums.length >= 2) {
      var a0 = axisOf(parts[0]), a1 = axisOf(parts[1]);
      if (a0 === 'h' || (a1 === 'w' && a0 !== 'w')) return { w: nums[1], h: nums[0] };
      return { w: nums[0], h: nums[1] };
    }
    if (nums.length === 1) return axisOf(parts[0]) === 'h' ? { w: 0, h: nums[0] } : { w: nums[0], h: 0 };
    return { w: 0, h: 0 };
  }
  var sizes = Array.prototype.map.call(fs.querySelectorAll('input[data-variant-input]'), function (inp) {
    var d = parseSize(inp.value);
    return { inp: inp, value: norm(inp.value), w: d.w, h: d.h };
  });
  if (sizes.length < 2 || !sizes.every(function (s) { return s.w > 0 || s.h > 0; })) return;
  var hasWH = sizes.every(function (s) { return s.w > 0 && s.h > 0; });
  var hasW = sizes.every(function (s) { return s.w > 0; });

  var SOFA = 84, SOFA_X = 8, ART_BOTTOM = 41;
  function isTall(s) { return s.h > 0 && (!s.w || s.h > s.w * 1.15); }
  function fitFor(s) {
    var bw = s.w || s.h;
    if (D.bathroom) return bw < 30 ? 'Over the toilet or a towel bar' : (bw < 43 ? 'Over the toilet or a single vanity' : 'Over the tub or a double vanity');
    if (isTall(s)) return s.h < 36 ? 'Hallway or beside a door' : (s.h < 56 ? 'Entryway or between windows' : 'Tall or vaulted wall');
    if (s.w < 36) return 'Desk, entryway, console';
    if (s.w < 50) return 'Over a sofa or queen bed';
    if (s.w < 59) return 'Long sofa or king headboard';
    return 'Sectional, king bed, big wall';
  }
  function tierFor(s) {
    var m = isTall(s) ? s.h : s.w;
    if (D.bathroom) return m < 30 ? 'Accent' : (m < 43 ? 'Classic' : 'Large');
    return m < 36 ? 'Accent' : (m < 50 ? 'Classic' : (m < 59 ? 'Large' : 'Statement'));
  }
  var popular = null;
  sizes.forEach(function (s) { if (D.popular && Math.round(s.w || s.h) === Math.round(D.popular)) popular = s; });
  function cm(n) { return Math.round(n * 2.54); }
  function inch(n) { return (Math.round(n * 10) / 10) + '"'; }
  function dimText(s) { return s.w && s.h ? inch(s.w) + ' × ' + inch(s.h) : (s.w ? inch(s.w) + ' wide' : inch(s.h) + ' tall'); }
  function money(c) { return '$' + (c % 100 ? (c / 100).toFixed(2) : String(c / 100)); }
  function track(name, params) { try { if (window.gtag) window.gtag('event', name, params || {}); } catch (e) {} }
  function el(html) { var t = document.createElement('template'); t.innerHTML = html.trim(); return t.content.firstChild; }

  function selected() {
    var out = [];
    for (var i = 0; i < 3; i++) {
      var f = meta.querySelector('.variant-input-wrap[data-index="option' + (i + 1) + '"]');
      var c = f ? f.querySelector('input[data-variant-input]:checked') : null;
      out.push(c ? norm(c.value) : null);
    }
    return out;
  }
  function priceFor(s, sel) {
    for (var i = 0; i < D.variants.length; i++) {
      var v = D.variants[i], ok = true;
      for (var k = 0; k < v.o.length; k++) {
        var want = k === D.sizeIndex ? s.value : sel[k];
        if (want != null && norm(v.o[k]) !== want) { ok = false; break; }
      }
      if (ok) return v.p;
    }
    return null;
  }
  function current() { return sizes.filter(function (s) { return s.inp.checked; })[0] || sizes[0]; }
  function clickSize(s) {
    var lab = s.inp.id ? fs.querySelector('label[for="' + s.inp.id + '"]') : null;
    if (lab) lab.click(); else { s.inp.checked = true; s.inp.dispatchEvent(new Event('change', { bubbles: true })); }
  }
  function pick(s, source) { clickSize(s); track('size_select', { size: s.value, source: source || 'card' }); setTimeout(update, 30); }

  // ---------- Cards ----------
  wrapper.classList.add('mp-sz-wrap');
  fs.classList.add('mp-sz-hidden');
  var ui = el('<div class="mp-sz-ui">' +
    '<div class="mp-sz" role="radiogroup" aria-label="Size"></div>' +
    '<p class="mp-sz__facts">Indoor &amp; outdoor · Mounting tape included · Free US shipping</p>' +
    '<div class="mp-sz__note"><svg viewBox="0 0 24 24" fill="none" stroke="#8E4426" stroke-width="1.8" aria-hidden="true"><circle cx="12" cy="12" r="9"></circle><path d="M12 11v6M12 7.5v.5"></path></svg><span>Cut-outs look lighter than a framed print because the wall shows through. <strong>Between sizes? Go up.</strong> <button type="button" data-mp-guide>Find my size</button></span></div>' +
    '</div>');
  var grid = ui.querySelector('.mp-sz');
  // Guide link sits on the same line as the theme's "Size: ..." label.
  var guideBtn = el('<button type="button" class="mp-sz__guide" data-mp-guide><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><rect x="2" y="8" width="20" height="8" rx="1"></rect><path d="M6 8v3M10 8v4M14 8v3M18 8v4"></path></svg>Size guide &amp; wall planner</button>');
  var sizeLabel = wrapper.querySelector('.variant__label');
  if (sizeLabel) {
    var labelRow = el('<div class="mp-sz__labelrow"></div>');
    sizeLabel.parentNode.insertBefore(labelRow, sizeLabel);
    labelRow.appendChild(sizeLabel);
    labelRow.appendChild(guideBtn);
  } else {
    var head = el('<div class="mp-sz__head"></div>');
    head.appendChild(guideBtn);
    ui.insertBefore(head, grid);
  }
  sizes.forEach(function (s, i) {
    var b = el('<button type="button" class="mp-sz__card" role="radio">' +
      (s === popular ? '<span class="mp-sz__badge">Most popular</span>' : '<span class="mp-sz__tier"></span>') +
      '<span class="mp-sz__row"><span class="mp-sz__dim"></span></span><span class="mp-sz__fit"></span></button>');
    if (s !== popular) b.querySelector('.mp-sz__tier').textContent = tierFor(s);
    b.querySelector('.mp-sz__dim').textContent = dimText(s);
    b.querySelector('.mp-sz__fit').textContent = fitFor(s);
    b.addEventListener('click', function () { pick(s, 'card'); });
    b.addEventListener('keydown', function (e) {
      var n = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = sizes[(i + 1) % sizes.length];
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = sizes[(i - 1 + sizes.length) % sizes.length];
      if (n) { e.preventDefault(); pick(n, 'keyboard'); n.card.focus(); }
    });
    s.card = b;
    grid.appendChild(b);
  });
  wrapper.parentNode.insertBefore(ui, wrapper.nextSibling);

  var FILLS = { black: '#161616', white: '#F4F3F0', silver: '#B9BCBF', gold: '#C9A44C', bronze: '#8C6A3C', copper: '#A4532E' };
  function setLine(l, x1, y1, x2, y2) { l.setAttribute('x1', x1); l.setAttribute('y1', y1); l.setAttribute('x2', x2); l.setAttribute('y2', y2); }
  function renderRoom(s, sel) {
    if (!room) return;
    var cx = SOFA_X + SOFA / 2, x = cx - s.w / 2, y = ART_BOTTOM - s.h, ly = y - 3.2;
    R.art.style.transform = 'translate(' + x + 'px,' + y + 'px) scale(' + (s.w / C.w) + ',' + (s.h / C.h) + ')';
    var color = D.colorIndex >= 0 ? String(sel[D.colorIndex] || '').toLowerCase() : 'black';
    var fill = '#161616';
    Object.keys(FILLS).forEach(function (k) { if (color.indexOf(k) > -1) fill = FILLS[k]; });
    R.path.setAttribute('fill', fill);
    setLine(R.lines[0], x, ly, x + s.w, ly);
    setLine(R.lines[1], x, ly - 1, x, ly + 1);
    setLine(R.lines[2], x + s.w, ly - 1, x + s.w, ly + 1);
    R.text.setAttribute('x', cx); R.text.setAttribute('y', ly - 1.4);
    R.text.textContent = inch(s.w) + ' wide · ' + cm(s.w) + ' cm';
    R.shown.textContent = 'Shown: ' + inch(s.w) + ' wide × ' + inch(s.h) + ' high over an 84" sofa';
    var pct = Math.round(s.w / SOFA * 100);
    var feel = pct < 45 ? 'Best on a smaller wall, over a desk or console.' : (pct <= 75 ? 'A balanced look over a sofa or bed.' : 'A bold statement on a large wall.');
    R.cap.textContent = 'About ' + pct + '% of the width of an 84" sofa. ' + feel + (s === popular ? ' Our most-ordered size.' : '');
  }

  // ---------- Size guide sheet ----------
  var sgTpl = document.getElementById('MpSgTpl');
  var sheet = sgTpl ? sgTpl.content.firstElementChild.cloneNode(true) : null;
  var G = {};
  if (sheet) {
    var titleEl = meta.querySelector('.product-single__title');
    sheet.querySelector('#MpSgName').textContent = titleEl ? norm(titleEl.textContent).split(' – ')[0] : 'Choose your size';
    var tbody = sheet.querySelector('tbody');
    sizes.forEach(function (s) {
      var tr = el('<table><tbody><tr><td><strong></strong><span class="mp-sg__tier"></span></td><td></td><td class="mp-sg__hide-sm"></td><td data-price></td></tr></tbody></table>').querySelector('tr');
      tr.querySelector('strong').textContent = dimText(s);
      var t = tr.querySelector('.mp-sg__tier');
      t.textContent = s === popular ? 'Most popular' : tierFor(s);
      if (s === popular) t.classList.add('mp-sg__tier--pop');
      tr.children[1].textContent = fitFor(s);
      tr.children[2].textContent = s.w && s.h ? cm(s.w) + ' × ' + cm(s.h) + ' cm' : cm(s.w || s.h) + ' cm';
      s.row = tr;
      tbody.appendChild(tr);
    });
    var presets = D.bathroom ? [[24, 'Toilet 24"'], [36, 'Vanity 36"'], [48, 'Vanity 48"'], [60, 'Tub 60"']] : [[48, 'Desk 48"'], [60, 'Queen 60"'], [76, 'King 76"'], [84, 'Sofa 84"']];
    if (D.bathroom) sheet.querySelector('[data-width-label]').textContent = 'How wide is the vanity, tub or wall space it will hang over?';
    var inputs = sheet.querySelector('.mp-sg__inputs');
    G.chips = presets.map(function (p) {
      var c = el('<button type="button" class="mp-sg__chip"></button>');
      c.textContent = p[1]; c.setAttribute('data-w', p[0]);
      c.addEventListener('click', function () { G.width.value = p[0]; renderGuide(); });
      inputs.appendChild(c);
      return c;
    });
    G.width = sheet.querySelector('#MpSgWidth');
    G.recSize = sheet.querySelector('[data-rec-size]');
    G.recWhy = sheet.querySelector('[data-rec-why]');
    G.width.addEventListener('input', renderGuide);
    if (!hasW) sheet.querySelector('.mp-sg__find').hidden = true;
    document.body.appendChild(sheet);
  }
  // ---------- Room panel ----------
  var C = D.cutout, room = null, R = {};
  var tooTall = sizes.some(function (s) { return ART_BOTTOM - s.h < 8; });
  var roomTpl = document.getElementById('MpRoomTpl');
  if (sheet && hasWH && C && C.d && C.w && C.h && !tooTall && roomTpl) {
    room = roomTpl.content.firstElementChild.cloneNode(true);
    // Lives inside the size guide (closed by default), so it never pushes Add to cart down.
    sheet.querySelector('.mp-sg__body').insertBefore(room, sheet.querySelector('.mp-sg__body').firstChild);
    R.art = room.querySelector('.mp-room__art');
    R.path = R.art.querySelector('path');
    R.path.setAttribute('d', C.d);
    R.lines = room.querySelectorAll('.mp-room__dim line');
    R.text = room.querySelector('.mp-room__dim text');
    R.shown = room.querySelector('.mp-room__shown');
    R.cap = room.querySelector('.mp-room__cap');
  }
  var recommended = null;
  function renderGuide() {
    if (!sheet) return;
    var sel = selected();
    sizes.forEach(function (s) {
      var p = priceFor(s, sel);
      s.row.querySelector('[data-price]').textContent = p != null ? money(p) : '';
    });
    if (!hasW) return;
    var W = parseFloat(G.width.value);
    if (!(W > 0)) W = 84;
    var target = W * 2 / 3, best = sizes[0];
    sizes.forEach(function (s) { if (Math.abs(s.w - target) < Math.abs(best.w - target)) best = s; });
    recommended = best;
    G.recSize.textContent = dimText(best) + ' ';
    var t = document.createElement('span');
    t.textContent = '· ' + (best === popular ? 'Most popular' : tierFor(best));
    G.recSize.appendChild(t);
    G.recWhy.textContent = 'About ' + Math.round(best.w / W * 100) + '% of your ' + Math.round(W) + '" width, close to the two-thirds rule.';
    G.chips.forEach(function (c) { c.setAttribute('aria-pressed', String(parseFloat(c.getAttribute('data-w')) === W)); });
    sizes.forEach(function (s) { s.row.classList.toggle('is-rec', s === best); });
  }
  var lastFocus = null;
  function openGuide() {
    if (!sheet) return;
    lastFocus = document.activeElement;
    renderGuide();
    sheet.classList.add('is-open');
    document.body.classList.add('mp-sg-lock');
    setTimeout(function () { sheet.querySelector('.mp-sg__close').focus(); }, 30);
    track('size_guide_open', {});
    if (room) track('room_panel_view', {});
  }
  function closeGuide() {
    sheet.classList.remove('is-open');
    document.body.classList.remove('mp-sg-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  ui.querySelectorAll('[data-mp-guide]').forEach(function (b) { b.addEventListener('click', openGuide); });
  guideBtn.addEventListener('click', openGuide);
  if (sheet) {
    sheet.querySelectorAll('[data-mp-close]').forEach(function (b) { b.addEventListener('click', closeGuide); });
    sheet.querySelector('[data-mp-use]').addEventListener('click', function () {
      var r = recommended;
      closeGuide();
      if (r) { pick(r, 'guide'); r.card.scrollIntoView({ behavior: 'smooth', block: 'center' }); r.card.focus({ preventScroll: true }); }
    });
    sheet.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeGuide(); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(sheet.querySelectorAll('button, input, a[href]'), function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
  }

  // ---------- Sync ----------
  function update() {
    var sel = selected(), cur = current();
    sizes.forEach(function (s) {
      var p = priceFor(s, sel), on = s === cur;
      s.card.setAttribute('aria-checked', on ? 'true' : 'false');
      s.card.tabIndex = on ? 0 : -1;
      s.card.setAttribute('aria-label', dimText(s) + ', ' + (p != null ? money(p) + ', ' : '') + fitFor(s) + (s === popular ? ', most popular' : ''));
    });
    renderRoom(cur, sel);
    if (sheet && sheet.classList.contains('is-open')) renderGuide();
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-variant-input]')) setTimeout(update, 30);
  });
  document.addEventListener('variant:change', function () { setTimeout(update, 30); });
  update();

  // Most popular size by default, only when the link names no variant (ads and DPA links keep their size).
  function applyDefault() {
    if (!popular || popular.inp.checked || /[?&]variant=/.test(location.search)) return;
    clickSize(popular);
    setTimeout(update, 30);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(applyDefault, 60); });
  else setTimeout(applyDefault, 60);

})();
